export const data = [
  {
    id: 1,
    title: 'Webtekno Analytics Verileri',
    titleEN: 'Webtekno Analytics Data',
    image: 'https://srv-cdn.onedio.com/store/38424d3e6b73dce47488a04930b512c989b6c23f1fc927b296cd6f8db204dda3.png',
    imageEN: 'https://srv-cdn.onedio.com/store/85baf103df79af6c39b5029edb58c6b47e0a610faeab1577824896d3b63b9b4d.png',
    active: true
  },
  {
    id: 2,
    title: 'Cinsiyet',
    titleEN: 'Gender',
    image: 'https://srv-cdn.onedio.com/store/caf138cc2ae6a1733f1e80233abf341be19c4af87d0cc00336d5d4209f1a1ed3.png',
    imageEN: 'https://srv-cdn.onedio.com/store/caf138cc2ae6a1733f1e80233abf341be19c4af87d0cc00336d5d4209f1a1ed3.png',
    active: false
  },
  {
    id: 3,
    title: 'Yaş Kırılımı',
    titleEN: 'Age Distribution',
    image: 'https://srv-cdn.onedio.com/store/f50927ddd3faf62c94ae51aed2c09fefe5ee66c7ac77ec2e84d49725a1f9c723.png',
    imageEN: 'https://srv-cdn.onedio.com/store/f50927ddd3faf62c94ae51aed2c09fefe5ee66c7ac77ec2e84d49725a1f9c723.png',
    active: false
  },
  {
    id: 4,
    title: 'Sosyal Medya',
    titleEN: 'Social Media',
    image: 'https://srv-cdn.onedio.com/store/9a3592ffefc68b8b59cd6210dc8ac8cc1b99f8f77ce0136deeaa707eccc97b86.png',
    imageEN: 'https://srv-cdn.onedio.com/store/682625cd422f3dcfdb9b559058ec23f55c23c54e33dfee9598a6a242998f7232.png',
    active: false
  }
]
